import _debounce from 'lodash/debounce';

export const stickyHeader = {
  name: 'sticky-header',
  inserted: (el) => {
    const SCROLL_UP = 'scroll-up';
    const SCROLL_DOWN = 'scroll-down';
    let LAST_SCROLL = 0;

    // Initial load check
    const initialScroll = window.pageYOffset;
    el.classList.add(initialScroll > 0 ? SCROLL_DOWN : SCROLL_UP);

    // Scroll event listener
    window.addEventListener(
      'scroll',
      _debounce(() => {
        if (document.querySelector('body')?.classList.contains('navOpen')) {
          return;
        }
        const currentScroll = window.pageYOffset;
        if (el.classList && currentScroll <= 0) {
          el.classList.remove(SCROLL_UP);
          return;
        }
        if (
          currentScroll > LAST_SCROLL &&
          !el.classList.contains(SCROLL_DOWN)
        ) {
          // down
          el.classList.remove(SCROLL_UP);
          el.classList.add(SCROLL_DOWN);
        } else if (
          currentScroll < LAST_SCROLL &&
          el.classList.contains(SCROLL_DOWN)
        ) {
          // up
          el.classList.remove(SCROLL_DOWN);
          el.classList.add(SCROLL_UP);
        }
        LAST_SCROLL = currentScroll;
      }, 0) // Set debounce time to 100ms for better performance
    );
  },
};
